import { number } from "yup";

export function NullableNumber(field: string) {
  return number()
    .typeError(`${field} has to be a number`)
    .nullable()
    .transform((value, originalValue) => (originalValue?.toString().trim() === "" ? null : value));
}
